import React, { useState } from 'react'
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';
import Button from 'components/shared/app/Button';
import './style.scss';
import { formatCurrency } from 'lib/utils/currency';
import Spinner from 'components/shared/app/Spinner';

const SignupReview = (props) => {
    const [error, setError] = useState(props.error || '');

    return (
        <div className="step signup-review form">

            <div className="font-plain-large bold pad lg center">Please review your information:</div>

            <div className="flex-col user-info">

                {props.profile &&
                    <div className="section profile">
                    <div className="header-row">
                        <h3>Profile:</h3>
                        <Button className="margin lg" round simple bold inline center color="white" textPosition="center" onClick={() => props.setSignupState(2)}>
                            Edit
                        </Button>
                    </div>

                        <div className="row">
                            <div className="label">Email:</div>
                            <div className="value">{props.profile.email}</div>
                        </div>

                        <div className="row">
                            <div className="label">Name:</div>
                            <div className="value">{props.profile.name}</div>
                        </div>

                        <div className="row">
                            <div className="label">Account Name:</div>
                            <div className="value">{props.profile.accountName}</div>
                        </div>
                    </div>
                }

                {props.profile &&
                    <div className="section goals">
                        <div className="header-row">
                            <h3>Goals:</h3>
                            <Button className="margin lg" round simple bold inline center color="white" textPosition="center" onClick={() => props.setSignupState(3)}>
                                Edit
                            </Button>
                        </div>

                        <div className="row">
                            <div className="label">Revenue:</div>
                            <div className="value">{formatCurrency(props.goals.revenueGoal)}</div>
                        </div>

                        <div className="row">
                            <div className="label">AOV:</div>
                            <div className="value">{formatCurrency(props.goals.aovGoal)}</div>
                        </div>

                        <div className="row">
                            <div className="label">CPP:</div>
                            <div className="value">{formatCurrency(props.goals.cppGoal)}</div>
                        </div>
                    </div>
                }

                {props.fbAccount &&
                    <div className="section profile">
                        <div className="header-row">
                            <h3>Facebook Account:</h3>
                            <Button className="margin lg" round simple bold inline center color="white" textPosition="center" onClick={() => props.setSignupState(1)}>
                                Edit
                            </Button>
                        </div>

                        <div className="row">
                            <div className="label">Account:</div>
                            <div className="value">{props.fbAccount}</div>
                        </div>

                        <div className="row">
                            <div className="label">Pixel:</div>
                            <div className="value">{props.fbPixel}</div>
                        </div>
                    </div>
                }

            </div>

            <div className="button-row col margin lg ns">
                <Button className="margin lg" round simple bold filled center color="white" icon={props.loading ? <Spinner size="small fit" className="icon" color="blue" /> : <img src={arrowIcon} />} iconPosition="right" textPosition="center" onClick={props.submit}>
                    Create Account
                </Button>
                <Button className="margin lg" round simple bold center color="white" textPosition="center" onClick={() => props.setSignupState(3)}>
                    Back
                </Button>
            </div>

            { error != '' && <div className="error status center font-plain-medium">{error}</div> }

        </div>
    )
}

export default SignupReview;